import * as React from "react";
import { forwardRef } from "react";
const SvgHubIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 17, height: 16, viewBox: "0 0 16 16", fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 8.199, cy: 6.105, r: 2.273, fill: "currentColor" }), /* @__PURE__ */ React.createElement("circle", { cx: 5.927, cy: 9.894, r: 2.273, fill: "currentColor" }), /* @__PURE__ */ React.createElement("circle", { cx: 10.473, cy: 9.894, r: 2.273, fill: "currentColor" }));
const ForwardRef = forwardRef(SvgHubIcon);
export default ForwardRef;
